import { LanguagesEnum } from '@/api/enums';
import { handleAxiosError } from '@/api/helpers';
import { ModifiedResource, Resource } from '@/client/courses';
import { DefaultVideoLanguageDropdown } from '@/components/courses/DefaultVideoLanguageDropdown';
import { useUpdateCourseResource } from '@/hooks/query/course-content.hooks';
import { useToast } from '@/hooks/useToast';
import React from 'react';

type VideoFallbackLanguageSectionProps = {
  courseId?: string;
  resource?: ModifiedResource;
  uploadedLanguages: LanguagesEnum[];
  isDisabled?: boolean;
  onUpdated: (resourceId: string, response: Resource) => void;
};

export const VideoFallbackLanguageSection: React.FC<
  VideoFallbackLanguageSectionProps
> = ({ courseId, resource, uploadedLanguages, isDisabled, onUpdated }) => {
  const toast = useToast();
  const { updateResource, isUpdatingResource } = useUpdateCourseResource();

  const selectedLanguage =
    resource?.fallbackLanguage ??
    (uploadedLanguages.includes(LanguagesEnum.EN)
      ? LanguagesEnum.EN
      : uploadedLanguages[0]);

  const handleChange = (language: LanguagesEnum) => {
    if (!courseId || !resource?.id) return;

    const resourceId = resource.id;

    updateResource(
      {
        courseId,
        resourceId,
        data: {
          id: resourceId,
          title: resource.title,
          type: resource.type,
          fallbackLanguage: language,
        },
      },
      {
        onSuccess: (response) => onUpdated(resourceId, response),
        onError: (error) => handleAxiosError(error, toast),
      },
    );
  };

  return (
    <DefaultVideoLanguageDropdown
      className="default-video-dropdown"
      validLanguages={uploadedLanguages}
      selectedLanguage={selectedLanguage}
      isDisabled={isDisabled || isUpdatingResource}
      onChange={handleChange}
    />
  );
};
